import React, { ForwardedRef, forwardRef, useContext } from "react"
import classNames from "classnames"
import { UnstyledButton } from "@mantine/core"

import { Icon } from "@/components"

import classes from "@/components/TopNavigation/components/MultiPacSelector/Target/Target.module.css"
import { MultiPacSelectorContext } from "@/components/TopNavigation/components/MultiPacSelector/MultiPacSelectorContext"

type Props = {
    isOpen: boolean
    onClick: () => void
    loggedInAsUser: boolean
    isMobile?: boolean
    popdownIsOpen?: boolean
}

export const Target = forwardRef(
    ({ isOpen, onClick, loggedInAsUser, isMobile, popdownIsOpen }: Props, ref: ForwardedRef<HTMLButtonElement>) => {
        const context = useContext(MultiPacSelectorContext)
        const { selectedPacLabel } = context

        return (
            <UnstyledButton
                type="button"
                onClick={onClick}
                className={classNames(classes.target, {
                    [classes.loggedInAsUser]: loggedInAsUser,
                    [classes.popdownOpen]: popdownIsOpen,
                })}
                ref={ref}
            >
                <Icon icon="dollar-sign" className={classes.dollarIcon} />
                <span title={selectedPacLabel}>{selectedPacLabel}</span>
                {!isMobile && <Icon icon={isOpen ? "angle-up" : "angle-down"} className={classes.angleIcon} />}
            </UnstyledButton>
        )
    },
)
